import React from 'react';
import styled from 'styled-components';

import infoImg from '~images/question.svg';
import { Tooltip } from '~ui-kit';

// This is an info button with a tooltip that can contain either just a string
// or any component
export default function InfoTooltip(props) {
  const { children, ...iconProps } = props; // eslint-disable-line no-unused-vars

  return (
    <Container>
      <Tooltip content={props.children || props.content}>
        <InfoIcon
          alt="info"
          src={infoImg}
          size={props.size || '25px'}
          {...iconProps}
        />
      </Tooltip>
    </Container>
  );
}

const Container = styled.div`
  display: inline-block;
`;

const InfoIcon = styled.img`
  width: ${props => props.size};
  height: ${props => props.size};
  margin-top: -3px;
`;
